// extracted by mini-css-extract-plugin
export default {"wrapper":"ImgSection_wrapper__MpYF8","imgItem":"ImgSection_imgItem__Ucl6C"};